/** @format */

import React, { useEffect, useState } from "react";

import Table1 from "./Table1";
import Table2 from "./Table2";
import Table3 from "./Table3";
import Tabs from "../../components/Tabs";
import ContentTop from "../../components/ContentTop";

const SuvomborlariSahifa = ({ setOmbor }) => {
  const [toggle, setToggle] = useState(1);
  const [date, setDate] = useState(new Date().toISOString().slice(0, 10));
  const [ldate, setLdate] = useState(date);

  const tabs = [
    { title: "1-Jadval", id: 1, type: "text" },
    { title: "2-Jadval", id: 2, type: "text" },
    { title: "3-Jadval", id: 3, type: "text" },
  ];

  useEffect(() => {}, [date]);

  useEffect(() => {
    setDate(ldate);
  }, [ldate]);

  return (
    <div>
      <ContentTop>
        <ul className='content-top-left suv-omborlari'>
          <li>Suv omborlari</li>
          <div>
            <Tabs toggle={toggle} setToggle={setToggle} tabs={tabs} />
          </div>
        </ul>

        <ul className='content-top-right'>
          <input
            type='date'
            className='form-control form-control-sm'
            value={ldate}
            onChange={(e) => setLdate(e.target.value)}
          />
        </ul>
      </ContentTop>

      <div className='tabs-content table-box'>
        <div
          className={
            toggle == 1 ? "tabs-content-item active" : "tabs-content-item"
          }>
          <Table1 date={date} setOmbor={setOmbor} />
        </div>

        <div
          className={
            toggle == 2 ? "tabs-content-item active" : "tabs-content-item"
          }>
          <Table2 date={date} setOmbor={setOmbor} />
        </div>

        <div
          className={
            toggle == 3 ? "tabs-content-item active" : "tabs-content-item"
          }>
          <Table3 date={date} setOmbor={setOmbor} />
        </div>
      </div>
    </div>
  );
};

export default SuvomborlariSahifa;
